import { Component, OnDestroy, OnInit } from '@angular/core';
import { AnalyticsService, AuthorizationService, LoggingService, TimePeriod } from 'app/shared';
import { BaseDetailsLogic } from 'app/analytics/BaseDetailsLogic';
import { CombinedSearchTermsConfig } from 'app/shared/model/charts/user-analytic-configurations.model';
import { TooltipCoordinatorService } from 'app/analytics/services/tooltip-coordinator.service';
import { CombinedSearchTermsData } from 'app/shared/model/manualsanalyticsdata.model';

@Component({
    selector: 'app-combined-search-terms-details',
    templateUrl: './combined-search-terms-details.component.html',
    standalone: false,
})
export class CombinedSearchTermsDetailsComponent
    extends BaseDetailsLogic<CombinedSearchTermsConfig>
    implements OnInit, OnDestroy {
    chartData: CombinedSearchTermsData | null = null;
    chartType: string = 'list';


    constructor(
        analyticsService: AnalyticsService,
        authService: AuthorizationService,
        loggingService: LoggingService,
        tooltipCoordinator: TooltipCoordinatorService
    ) {
        super(analyticsService, authService, loggingService, CombinedSearchTermsConfig, tooltipCoordinator);

        this.analyticsService.combinedSearchTermsDataChange.subscribe((data: CombinedSearchTermsData) => {
            this.chartData = data;
        });
    }

    get selectedTimePeriod(): string | TimePeriod {
        return this.config?.period as TimePeriod;
    }

    set selectedTimePeriod(value: string | TimePeriod) {
        this.config.period = value;
        this.detectSettingsChange();
        this.refreshDataFromFilters();
    }

    get selectedMinUsed(): number {
        return this.config?.minUsed || 1;
    }

    set selectedMinUsed(value: number) {
        this.config.minUsed = value;
        this.detectSettingsChange();
        this.refreshDataFromFilters();
    }

    ngOnInit(): void {
        super.init();
    }

    ngOnDestroy(): void {
        super.cleanup();
    }

    protected getInfoTexts(): { [key: string]: string } {
        return {
            minUsed:
                "Set the minimum number of times a search term must be used to appear in the list. For example, if you enter 5, you will only see search terms that were used at least 5 times. This applies to both global and document-specific searches combined.",
        };
    }
}